export default "__VITE_PUBLIC_ASSET__a1bbd5f1__"